/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import React from 'react';
import {CommonVehicleDetails} from "../../Functionality/VehicleDetailsFlows/CommonVehicleDetails";
import {CommonMainDetailsApp} from "../../../../Dashboard/Contractors/Functionality/ContractorDetailsFlows/CommonMainDetailsApp";
import routes from "../../../../../Routes/routes";
import HeadTittle from "../../../../../components/HeadTittle";
import VehicleDetailsBody from "./VehicleDetailsBody";
import DivContainerBody from "../../../../../components/DivContainerBody";

const VehicleDetailsFromContractFlowContract = () => {
    const props = CommonMainDetailsApp();
    const {
        t,
        elementDetails,
        elementDocuments,
    }  = props;

    const {contractId} = CommonVehicleDetails(props);

    return (
        <>
            <HeadTittle name={t('details1')} link={routes.contractor.contractDetails + contractId}/>
            <DivContainerBody>
                <VehicleDetailsBody
                    disabled={true}
                    elementDetails={elementDetails}
                    elementDocuments={elementDocuments}
                />
            </DivContainerBody>
        </>
    );
};

export default VehicleDetailsFromContractFlowContract;
